import * as api from 'services/api';

// services/api/index.js dispatches `${action}_SUCCESS` with the response body
// as payload — so this is the suffix the reducer matches against.
export const FEATURES = 'FEATURES';
export const FEATURES_SUCCESS = `${FEATURES}_SUCCESS`;

// Mirror of the backend's `global.features` map (see backend/shared/features.js).
// Fetched once at app boot and used to hide UI for feature flags that are off
// on the current environment — e.g. the Consultants menu item on jobalto.com.
export const fetchFeatures = () => (dispatch) =>
  api.get('features', FEATURES, dispatch);
